@switch (columnName) {
  @case ('expires') {
    {{ element[columnName] | date }}
  }
  @case ('productName') {
    {{ element.name }}
  }
  @case ('currentQuantity') {
    {{ element.quantity }}
  }
  @case ('quantityType') {
    {{ element.quantityType?.name }}
  }
  @case ('minQuantity') {
    {{ element.minimumQuantity }}
  }
  @case ('chemical') {
    @if (element.isChemical) {
      <mat-icon>science</mat-icon>
    }
  }
  @case ('critical') {
    @if (element.isChemical) {
      <mat-icon>warning</mat-icon>
    }
  }
  @case ('components') {
    @for (component of element.components; track component) {
      <div>
        {{ (component?.sfiCode ? component.sfiCode + ' ' : '') + component?.name || '-' }}
      </div>
    }
  }
  @case ('description') {
    {{ element.reason }}
  }
  @case ('status') {
    <app-ui-pill [name]="statusColor"></app-ui-pill>
  }
  @case ('department') {
    {{ element.department.name }}
  }
  @case ('date') {
    {{ element.date | date }}
  }
  @case ('changedBy') {
    {{ element.changedBy | fullName }}
  }
  @case ('event') {
    {{ element.storageProductAction | mapProductAction | translate }} {{ transferDepartmentLabel }}
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
  @case ('actionButton') {
    <div class="display-flex">
      <app-ui-button
        text="{{ 'addToStock' | translate }}"
        buttonType="secondary"
        (click)="addToStock()"
        privilege="STORAGE-PRODUCT_UPDATE"
      ></app-ui-button>
      <app-ui-button
        class="use-button"
        buttonType="secondary"
        text="{{ 'use' | translate }}"
        (click)="use()"
        privilege="STORAGE-PRODUCT_UPDATE"
      ></app-ui-button>
      @if (hasMultipleDepartments()) {
        <app-ui-button
          buttonType="secondary"
          text="{{ 'transfer' | translate }}"
          (click)="openTransferDialog()"
          [privilege]="Privileges.StorageProductTransfer"
          [disabled]="element.quantity < 1"
          [tooltip]="(element.quantity < 1 ? 'insufficientStockForTransfer' : '') | translate"
        ></app-ui-button>
      }
    </div>
  }
}
